import React, { useEffect, useMemo, useState } from "react";
import translator from "../Extra/Translation/Translate";
import UtilsService from "../../Services/UtilsService";
import { UserCryptoWallet } from "../../Models/UserWallet";
import { useAssets } from "../../App/Provider/AssetsProvider";
import ScratchTicketBox from "./ScratchBox/ScratchTicketBox";
import BoxMysteryBox from "./MysteryBox/BoxMysteryBox";
import SettingService, {
    DefiGroup,
} from "../../Services/Setting/SettingService";
import { BoxItem } from "./BoxItem";
const InfinityPage = () => {
    const { translate } = translator();
    const { assets } = useAssets();
    const assetInf: UserCryptoWallet | null = useMemo(() => {
        const res = assets.find(
            (elt) => elt.type === "fiat" && elt.abbreviation === "INF",
        );
        return res || null;
    }, [assets]);
    const [status, setStatus] = useState("pending");
    const [defisDataCompleted, setDefisDataCompleted] = useState<
        DefiGroup[] | undefined
    >(undefined);

    const [defisDataPending, setDefisDataPending] = useState<
        DefiGroup[] | undefined
    >(undefined);

    const getDefisHistoryByUser = async () => {
        const result = await SettingService.getDefisHistoryByUser();

        const completedGroups = result.filter(
            (group) => group.completed && group.completed.length > 0,
        );
        setDefisDataCompleted(completedGroups);
        const pendingGroups = result.filter(
            (group) => group.inProgress !== null,
        );
        setDefisDataPending(pendingGroups);
    };

    useEffect(() => {
        getDefisHistoryByUser();
    }, []);

    useEffect(() => {
        console.log("status", status);
    }, [status]);
    const boxes = [
        {
            url: "/subscription",
            image: "/dist/image/Isometric-Subscribe.png",
            title: translate("INFINITY", "Defi_2_Title"),
            description: translate("INFINITY", "Defi_2_Desc"),
            points: "25",
            progress: {
                current: 0,
                total: 1,
            },
            key: "defis_subscription_first",
        },
        {
            url: "/settings",
            image: "/dist/image/Isometric-Secure.png",
            title: translate("INFINITY", "Defi_3_Title"),
            description: translate("INFINITY", "Defi_3_Desc"),
            points: "3",

            progress: {
                current: 0,
                total: 1,
            },
            key: "defis_transaction_password_creation",
        },
        {
            url: "/settings",
            image: "/dist/image/Isometric-Secure3.png",
            title: translate("INFINITY", "Defi_4_Title"),
            description: translate("INFINITY", "Defi_4_Desc"),
            points: "3",
            progress: {
                current: 0,
                total: 1,
            },
            key: "defis_two_fa_activation",
        },
        {
            url: "/subscription",
            image: "/dist/image/Isometric-Subscribe2.png",
            title: translate("INFINITY", "Defi_5_Title"),
            description: translate("INFINITY", "Defi_5_Desc"),
            points: "75",
            progress: {
                current: 0,
                total: 1,
            },
            key: "defis_subscription_upgrade",
        },
        {
            url: "/referrals",
            image: "/dist/image/Isometric-Affiliates3.png",
            title: translate("INFINITY", "Defi_6_Title"),
            description: translate("INFINITY", "Defi_6_Desc"),
            points: "10",
            progress: {
                current: 0,
                total: 25,
            },
            key: "defis_referral_user_registered",
        },
        {
            url: "/exchange",
            image: "/dist/image/Isometric-Earn.png",
            title: translate("INFINITY", "Defi_7_Title"),
            description: translate("INFINITY", "Defi_7_Desc", {
                amount: "25",
            }),
            points: "10",
            progress: {
                current: 0,
                total: 50,
                label: "€",
            },
            key: "defis_exchange_reward_single",
            is_translate: "Defi_7_Desc",
        },
        {
            url: "/exchange",
            image: "/dist/image/Isometric-Saving2.png",
            title: translate("INFINITY", "Defi_9_Title"),
            description: translate("INFINITY", "Defi_9_Desc", {
                amount: "25",
            }),
            points: "60",
            progress: {
                current: 0,
                total: 50,
                label: "€",
            },
            key: "defis_exchange_reward_recurring",
            is_translate: "Defi_9_Desc",
        },
        {
            url: "/savings-plans",
            image: "/dist/image/Isometric-Card.png",
            title: translate("INFINITY", "Defi_10_Title"),
            description: translate("INFINITY", "Defi_10_Desc", {
                amount: "25",
            }),
            points: "10",
            progress: {
                current: 0,
                total: 50,
                label: "€",
            },
            key: "defis_saving_reward_single",
            is_translate: "Defi_10_Desc",
        },
        {
            url: "/savings-plans",
            image: "/dist/image/Isometric-Exchange2.png",
            title: translate("INFINITY", "Defi_11_Title"),
            description: translate("INFINITY", "Defi_11_Desc", {
                amount: "25",
            }),
            points: "25",
            progress: {
                current: 0,
                total: 50,
                label: "€",
            },
            key: "defis_saving_reward_recurring",
            is_translate: "Defi_11_Desc",
        },
    ];
    return (
        <div className="w-full">
            {/* Titre de la page */}
            <div className="text-left my-6">
                <h1 className=" mr-auto font-medium text-2xl">
                    {translate("INFINITY", "Defis_Title")}
                </h1>
            </div>

            {/* Mobile First section */}
            <div className="pt-3 mx-0 px-0 sm-block"></div>
            <div className="box px-4 mx-0 sm-block mb-2 dark:!border-2 dark:!border-slate-700">
                <div className="md-flex justify-between items-center py-4 px-2">
                    <div className="flex items-center sm:h-[50px]">
                        <div className="block sm:w-full text-center">
                            <div className="text-base font-medium text-center">
                                {translate("INFINITY", "Infinity_Pts")}
                                <div className="inline-flex text-lg "></div>
                                <div className="text-base text-slate-500 flex justify-center items-center text-center">
                                    <div className="flex items-center text-center mt-1">
                                        <div className="">
                                            <div className="h-[30px] md:!h-[30px] flex justify-center items-center text-center text-xl md:!text-2xl lg:!text-2xl font-bold px-5">
                                                <span>
                                                    {assetInf?.wallet?.solde ??
                                                        0}
                                                </span>
                                                <img
                                                    src="/dist/image/Fav-Infinexia-512x512.webp"
                                                    className="w-6 h-6 mx-2"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Invite Friends section */}
            <div className="pt-3 mx-0 px-0 sm-block"></div>
            <div className="intro-y box px-4 mx-0 sm-block mb-2 dark:!border-2 dark:!border-slate-700">
                <div className="md-flex justify-between items-center py-1 px-2 w-full">
                    <div className="flex items-center w-full h-auto">
                        <div className="block w-[60%]">
                            <div className="text-base font-medium">
                                {translate("INFINITY", "Earn_more-1")}
                            </div>
                            <div className="text-sm text-slate-500">
                                {translate("INFINITY", "Earn_more-2")}
                            </div>
                        </div>
                        <div className="h-24 w-40">
                            <img
                                src={UtilsService.getPulicImage(
                                    "/dist/image/InviteFriend.webp",
                                )}
                                alt=""
                                className="h-full w-full rounded-lg object-fill"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* END Mobile section */}

            {/* Desktop Section 1 */}
            <div className="pt-3 "></div>
            <div className="intro-y flex-1  border-slate-200/60  lg:border-0 !mt-[-12px] ">
                <div className="grid grid-cols-12 gap-6 mt-[12px] ">
                    <div className="col-span-12 ">
                        <div className="grid grid-cols-12 gap-6 bg-force">
                            <div className="col-span-12 box py-4 px-3 hidden md:block dark:!border-2 dark:!border-slate-700">
                                <div className="-mx-5 flex flex-col pb-5 lg:flex-row relative p-3">
                                    <div className="block px-5 mb-3 md-w-50">
                                        <div className="my-3 md-flex w-full items-mt-1 flex items-center justify-top mb-2 w-full">
                                            <div className="h-24 w-40">
                                                <img
                                                    src={UtilsService.getPulicImage(
                                                        "/dist/image/InviteFriend.webp",
                                                    )}
                                                    alt=""
                                                    className="h-auto w-full rounded-lg object-fill"
                                                />
                                            </div>
                                            <div className="block w-full md-mt">
                                                <div className="text-lg font-bold my-1">
                                                    {translate(
                                                        "INFINITY",
                                                        "Earn_more-3",
                                                    )}
                                                </div>
                                                <div className="w-full text-slate-500">
                                                    {translate(
                                                        "INFINITY",
                                                        "Spend_pts",
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="inline-flex items-center justify-center h-full sm-hidden">
                                        <hr className="h-20 w-px my-8 dark:!bg-slate-700 dark:!border-b dark:!border-slate-700" />
                                    </div>

                                    {/* Desktop Section 2 */}
                                    <div className="pt-7 block px-5 mb-3 md-w-50">
                                        <div className="my-3 md-flex w-full items-mt-1 flex items-center justify-top mb-2 w-full">
                                            <div className="block w-full md-mt ml-10">
                                                <div className="block md:flex pt-2">
                                                    <div className="block w-full">
                                                        <div className="h-[30px] md:!h-[30px] flex justify-center items-center text-left text-xl md:!text-2xl lg:!text-2xl font-bold px-5">
                                                            <div className="text-left text-xl md:!text-2xl lg:!text-2xl font-bold">
                                                                <span className="text-lg font-bold my-1">
                                                                    {translate(
                                                                        "INFINITY",
                                                                        "Infinity_Pts",
                                                                    )}{" "}
                                                                </span>
                                                                <div className="text-lg md:!text-xl lg:!text-2xl flex justify-center items-center">
                                                                    {assetInf
                                                                        ?.wallet
                                                                        ?.solde ??
                                                                        0}
                                                                    <img
                                                                        src="/dist/image/Fav-Infinexia-512x512.webp"
                                                                        className="w-6 h-6 mx-2"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Au dessus des box on affiche les boutons "En cours" & "Terminés" */}
            <div className="w-full mx-auto">
                {/* HEADER avec boutons de filtre "En cours" & "Terminés"*/}
                <div className="mt-10 flex justify-left ml-2">
                    <ul className="flex space-x-2">
                        <li>
                            <button
                                onClick={() => setStatus("pending")}
                                className={`px-4 py-1 rounded-full text-sm font-medium shadow-sm ${
                                    status === "pending"
                                        ? "btn btn-perfect inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm bg-indigo-500 text-white duration-150 ease-in-out"
                                        : "inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 shadow-sm bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 duration-150 ease-in-out"
                                }`}
                            >
                                {translate("INFINITY", "En cours")}
                            </button>
                        </li>
                        <li>
                            <button
                                onClick={() => setStatus("completed")}
                                className={`px-4 py-1 rounded-full text-sm font-medium shadow-sm ${
                                    status === "completed"
                                        ? "btn btn-perfect inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm bg-indigo-500 text-white duration-150 ease-in-out"
                                        : "inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 shadow-sm bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 duration-150 ease-in-out"
                                }`}
                            >
                                {translate("INFINITY", "Terminés")}
                            </button>
                        </li>
                    </ul>
                </div>

                <div className="mt-4 grid sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 sm:!gap-2 md:!gap-4">
                    <BoxMysteryBox />
                    {status === "pending" && defisDataPending && (
                        <>
                            {boxes.map((box, index) => (
                                <BoxItem
                                    key={index}
                                    box={box}
                                    defis={defisDataPending}
                                    translate={translate}
                                    status="pending"
                                />
                            ))}
                        </>
                    )}

                    {status === "completed" && defisDataCompleted && (
                        <>
                            {boxes.map((box, index) => (
                                <BoxItem
                                    key={index}
                                    box={box}
                                    defis={defisDataCompleted}
                                    translate={translate}
                                    status="completed"
                                />
                            ))}
                        </>
                    )}
                </div>

                <div className="mt-10 grid sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 sm:!gap-2 md:!gap-4">
                    <ScratchTicketBox />
                </div>
            </div>
        </div>
    );
};

export default InfinityPage;
